export default {
  GATSBY_CURRENT_NEWSLETTER: "https://us20.campaign-archive.com/?u=6f24d70d89d3ce7950479031a&id=e17af76159",
  GATSBY_CURRENT_NEWSLETTER_PDF: "http://admin.memocracy.eu/wp-content/uploads/2024/09/Newsletter-III-2023-2024-1-3.pdf",
}
